<template>
  <div id="app" class="new-color">
    <VMain>
      <VApp>
        <loader v-show="loader" />
        <component :is="layout">
          <router-view />
        </component>
        <!-- <PopupBanner /> -->
        <LightBox v-if="showLightBox" />
        <PopupCookiePolicy />
      </VApp>
    </VMain>
  </div>
</template>

<script>
import { parseISO, isAfter, isBefore } from 'date-fns';

const defaultLayout = 'default';

export default {
  name: 'App',
  metaInfo: {
    titleTemplate:
      '%s | eureciclo: Solução para logística reversa de embalagens',
    link: [{ rel: 'canonical', href: `${window.location.href}` }],
  },
  components: {
    Loader: () => import('@/components/Loader.vue'),
    // PopupBanner: () => import('@/components/PopupBanner.vue'),
    LightBox: () => import('@/components/LightBox.vue'),
    PopupCookiePolicy: () => import('@/components/PopupCookiePolicy.vue'),
  },
  data() {
    return {
      showLightBox: false,
    };
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
    bgImage() {
      return this.$route.meta.backgroundImage;
    },
    loader() {
      return this.$store.getters.loaderActive;
    },
  },
  watch: {
    $route() {
      if (
        this.$route.name === 'jobs' ||
        this.$route.name === 'vacancy' ||
        this.$route.name === 'burle' ||
        this.$route.name === 'onda-circular' ||
        this.$route.name === 'cmo' ||
        this.$route.name === 'lp-saopaulo'
      ) {
        // Hide whatsapp button
        document.getElementById('robbu-whatsapp-button').style.display = 'none';

        window.addEventListener('load', () => {
          /* eslint-disable prefer-destructuring */
          const scripts = document.scripts;

          scripts.forEach(script => {
            if (
              script.src ===
              'https://script.hotjar.com/survey-v2.238795b6c23bbf4ef085.js'
            ) {
              document.querySelector('._hj-widget-container').style.display =
                'none';
              document.querySelector('._hj-widget-container').style.opacity = 0;
              document.querySelector('._hj-widget-container').style.visibility =
                'hidden';
            }
          });
        });
      } else {
        // Show whatsapp button
        document.getElementById('robbu-whatsapp-button').style.display = 'flex';
        /* eslint-disable prefer-destructuring */
        const scripts = document.scripts;

        scripts.forEach(script => {
          if (
            script.src ===
            'https://script.hotjar.com/survey-v2.238795b6c23bbf4ef085.js'
          ) {
            if (document.querySelector('._hj-widget-container')) {
              document.querySelector('._hj-widget-container').style.display =
                'block';
              document.querySelector('._hj-widget-container').style.opacity = 1;
              document.querySelector('._hj-widget-container').style.visibility =
                'visible';
            }
          }
        });
      }
    },
  },
  mounted() {
    const dateStart = '2023-10-03 23:59:00';
    const dateFinish = '2023-12-05 11:00:00';
    const parsedDateStart = parseISO(dateStart);
    const parsedDateFinish = parseISO(dateFinish);

    const past = isAfter(new Date(), parsedDateStart);
    const future = isBefore(new Date(), parsedDateFinish);

    if (past && future) {
      this.showLightBox = true;
    }
  },
  methods: {},
};
</script>

<style lang="sass">
html
  scroll-behavior: smooth

#app
  width: 100%
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #59595c
  &.new-color
    color: #003036
    .v-btn
      font-family: 'metropolismedium' !important
      font-weight: normal !important
</style>
